import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logOut, setCredentials } from '@reducers/authSlice';
import { clearUser } from '@reducers/userSlice';
import { setIsErrorAfter401 } from '@reducers/notificationSlice';

export const createBaseQueryWithReauth = (baseUrl) => {
    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        credentials: 'same-origin',
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        }
    });

    return async (args, api, extraOptions) => {
        let result = await rawBaseQuery(args, api, extraOptions);
        const refresh_token = JSON.parse(localStorage.getItem('jwt_refresh'));
        if (result?.error?.status === 401 && api.getState().auth.isAuth) {
            const username = JSON.parse(localStorage.getItem('user'))?.username;
            const token = api.getState().auth.token;

            try {
                const refreshResult = await fetchBaseQuery({
                    baseUrl: import.meta.env.VITE_OQULYQTAR_API_URL, // реавторизация через VITE_OQULYQTAR_API_URL
                    credentials: 'same-origin'
                })({
                    url: '/public/auth',
                    method: 'POST',
                    body: { username, grant_type: 'refresh_token', refresh_token }
                }, api, extraOptions);

                const newToken = refreshResult.data.access_token;
                const newHeaders = {
                    ...extraOptions?.headers,
                    Authorization: `Bearer ${newToken}`
                };
                api.dispatch(setCredentials(newToken));
                localStorage.setItem('jwt_refresh', JSON.stringify(refreshResult.data.refresh_token));
                return await rawBaseQuery(args, api, { ...extraOptions, headers: newHeaders });

            } catch (error) {
                if (token) {
                    await fetchBaseQuery({
                        baseUrl: import.meta.env.VITE_OQULYQTAR_API_URL,
                        credentials: 'same-origin'
                    })({
                        url: '/oauth/logout',
                        method: 'POST',
                        body: { access_token: token }
                    }, api, extraOptions);
                }
                api.dispatch(setIsErrorAfter401(true));
                api.dispatch(logOut());
                api.dispatch(clearUser());
                window.history.pushState(null, null, '/');
            }
        }

        return result;
    };
};
